import { jsxs, jsx } from "react/jsx-runtime";
import Card from "antd/es/card";
import classnames from "../../utils/classnames.js";
import Button from "../Button/Button.js";
import Col from "../Grid/Col.js";
import "react";
import Row from "../Grid/Row.js";
import './FinanceCalc.css';import '../Grid/Grid.css';/* empty css                */
import Price from "../Price/Price.js";
import Typography from "../Typography/Typography.js";
/* empty css                 */
const FinanceCalc = ({
  className,
  title,
  icon,
  priceLabel,
  priceValue,
  buttonLabel,
  buttonIcon,
  onButtonClick
}) => {
  return /* @__PURE__ */ jsxs(Card, { className: classnames("perxis-auto-finance-calc", className), hoverable: true, children: [
    /* @__PURE__ */ jsxs(Row, { className: classnames("perxis-auto-finance-calc__header"), justify: "space-between", align: "middle", children: [
      /* @__PURE__ */ jsx(Col, { span: 20, children: /* @__PURE__ */ jsx(Typography.Title, { headingLevel: 3, level: "h2", children: title }) }),
      /* @__PURE__ */ jsx(Col, { span: 4, children: /* @__PURE__ */ jsx(Row, { justify: "end", children: /* @__PURE__ */ jsx(Col, { children: icon }) }) })
    ] }),
    /* @__PURE__ */ jsxs(
      Row,
      {
        className: classnames("perxis-auto-finance-calc__footer"),
        justify: priceValue ? "space-between" : "end",
        align: "middle",
        children: [
          /* @__PURE__ */ jsx(Col, { xs: 24, sm: 12, children: !!priceValue && /* @__PURE__ */ jsx(Price, { value: priceValue, title: priceLabel }) }),
          /* @__PURE__ */ jsx(Col, { xs: 24, sm: 12, children: /* @__PURE__ */ jsx(Row, { justify: "end", children: /* @__PURE__ */ jsx(Col, { className: classnames("perxis-auto-finance-calc__button-col"), children: /* @__PURE__ */ jsx(Button, { type: "ghost", onClick: onButtonClick, icon: buttonIcon, children: buttonLabel }) }) }) })
        ]
      }
    )
  ] });
};
export {
  FinanceCalc as default
};
//# sourceMappingURL=FinanceCalc.js.map
